export default "__VITE_ASSET__BIG1a_Kq__"